import dayjs from "dayjs"

export const STATUS_COLOR = {
  active: "success",
  inactive: "default"
}

export const formatValue = (record) => {
  if (record.discount_type === "percentage") return `${Number(record.value).toFixed(0)}%`
  return `$${Number(record.value).toFixed(2)}`
}

export const formatDateRange = (validFrom, validUntil) => {
  const fromDate = validFrom ? dayjs(validFrom) : null
  const untilDate = validUntil ? dayjs(validUntil) : null
  const fromValid = fromDate?.isValid()
  const untilValid = untilDate?.isValid()
  if (!fromValid && !untilValid) return "No expiry"
  const from = fromValid ? fromDate.format("MMM D, YYYY") : "—"
  const until = untilValid ? untilDate.format("MMM D, YYYY") : "No expiry"
  return `${from} → ${until}`
}

export const formatCap = (value) => {
  const isUnlimited = !value || value === "unlimited"
  return isUnlimited ? "∞" : value
}
